import { Link } from "react-router-dom";
import { LockKeyhole, Scale } from "lucide-react";

const Navbar2 = () => {
    return (
        <header className='w-full z-10 bg-sbPallet-cardBg/90 fixed lg:px-24 flex items-center justify-center'>
            <Link to="/" className='w-[40%] lg:w-[20%] flex justify-center' aria-label="Inicio">
                <img className='w-full p-1' src="/assets/RaulPerezLogoFinal.png" alt="Raul perez logo"/>
            </Link>

            <Link
                to="/equivalencias"
                data-testid="navbar-equivalencias-link"
                aria-label="Equivalencias"
                title="Equivalencias"
                className='group absolute left-2 sm:left-6 lg:left-24 top-1/2 -translate-y-1/2 flex items-center gap-2 h-8 sm:h-9 px-2.5 sm:px-4 rounded-full border border-sbPallet-accent/50 bg-sbPallet-accent/10 text-white text-[9px] sm:text-[11px] font-semibold uppercase tracking-normal sm:tracking-widest hover:bg-sbPallet-accent hover:border-sbPallet-accent transition-colors duration-200'
            >
                <Scale className='hidden sm:block h-3.5 w-3.5 text-sbPallet-accent group-hover:text-white transition-colors' />
                <span>Equivalencias</span>
            </Link>

            <Link
                to="/admin"
                data-testid="navbar-admin-link"
                aria-label="Acceder al panel"
                title="Acceder al panel"
                className='group absolute right-3 sm:right-6 lg:right-24 top-1/2 -translate-y-1/2 flex items-center gap-2 h-9 px-2.5 sm:px-4 rounded-full border border-white/15 text-white/60 text-[11px] font-semibold uppercase tracking-widest hover:text-white hover:border-sbPallet-accent hover:bg-sbPallet-accent/10 transition-colors duration-200'
            >
                <LockKeyhole className='h-3.5 w-3.5 text-sbPallet-accent' />
                <span className='hidden sm:inline'>Acceder al panel</span>
            </Link>
        </header>
    )
}

export default Navbar2
